import { LogChannel } from '@rx-applications/shared/logging';

export enum EventName {
  FullConfigLoaded = 'FullConfigLoaded',
  DidSearch = 'DidSearch',
  SelectedTopLocation = 'SelectedTopLocation',
  LandedOnLandingPage = 'LandedOnLandingPage',
  ShowMapForHotel = 'ShowMapForHotel',
  ShowMapForLocation = 'ShowMapForLocation',
  LandedOnLocationSearchPage = 'LandedOnLocationSearchPage',
  TermsAndConditionsClicked = 'TermsAndConditionsClicked',
  LocationSearchResponse = 'LocationSearchResponse',
  SelectedHotel = 'SelectedHotel',
  ClickedRoomDescription = 'ClickedRoomDescription',
  SelectedRecentHotel = 'SelectedRecentHotel',
  LandedOnLoginScreen = 'LandedOnLoginScreen',
  LandedOnReports = 'LandedOnReports',
  ReportDashboard = 'ReportDashboard',
  RoomexPaySplash = 'RoomexPaySplash',
  LandedOnCustomerDetailsPage = 'LandedOnCustomerDetailsPage',
  ClickedCustomerDetailsErrorLink = 'ClickedCustomerDetailsErrorLink',
  ReservationCreateResponse = 'ReservationCreateResponse',
  FinalizedBooking = 'FinalizedBooking',
  SentSpecialRequest = 'SpecialRequestPostBooking',
  ChangeSort = 'ChangeSort',
  ChangedFilter = 'ChangedFilter',
  ChangedPriceRangeFilter = 'ChangedPriceRangeFilter',
  PriceRangeFilterInteractions = 'PriceRangeFilterInteractions',
  ChangedStarRatingFilter = 'ChangedStarRatingFilter',
  ExpandedSearchRadius = 'ExpandedSearchRadius',
  LandedOnRoomSelectPage = 'LandedOnRoomSelectPage',
  RoomOptionClickResponse = 'RoomOptionClickResponse',
  SelectedRooms = 'SelectedRooms',
  AmendmentButtonClicked = 'AmendmentButtonClicked',
  AmendGuestClicked = 'AmendGuest',
  SubmitGuestNameChangeClicked = 'SubmitGuestNameChange',
  GuestNameAutoChanged = 'GuestNameAutoChanged',
  GuestNameManuallyChanged = 'GuestNameManuallyChanged',
  ReportDateRange = 'ReportDateRange',
  PWAAvailable = 'PWAAvailable',
  PWAActivated = 'PWAActivated',
  PWADownloaded = 'DownloadedPWA',
  PWADismissed = 'DismissedPWA',
  NoAvailabilityLocation = 'NoAvailabilityLocation',
  NoAvailabilityHotel = 'NoAvailabilityHotel',
  LocationTooLarge = 'LocationTooLarge',
  LandedGroupBookingPopOut = 'LandedGroupBookingPopOut',
  GroupBookingPopOutSent = 'GroupBookingPopOutSent',
  LandedGroupBookingHelp = 'LandedGroupBookingHelp',
  GroupBookingHelpSent = 'groupBookingHelpSent',
  LandedFAQHelpPage = 'landedFAQHelpPage',
  LandedContactHelpPage = 'LandedContactHelpPage',
  BookingEnquirySent = 'BookingEnquirySent',
  GeneralFeedbackSent = 'GeneralFeedbackSent',
  LandedlCancellationHelpPage = 'landedlCancellationHelpPage',
  ApartmentRequestSent = 'ApartmentRequestSent',
  LandedOnBookingsPage = 'LandedOnBookingsPage',
  LandedOnViewConfirmationPage = 'LandedOnViewConfirmationPage',
  LandedHotelDetailsPage = 'LandedHotelDetailsPage',
  GalleryImageClicked = 'GalleryImageClicked',
  SelectedMoreOptions = 'SelectedMoreOptions',
  AmendDates = 'AmendDates',
  CompleteAutoDateChange = 'CompleteAutoDateChange',
  SubmitManualDateChange = 'SubmitManualDateChange',
  DateChangeNoAvailability = 'DateChangeNoAvailability',
  RequestedRoomexPayCardAfterBooking = 'RequestedRoomexPayCardAfterBooking',
  AddedRoomexPayCardAfterBooking = 'AddedRoomexPayCardAfterBooking',
  RoomexPayLead = 'RoomexPayLead',
  LandedOnReportsBookerPage = 'LandedOnReportsBookerPage',
  LandedOnReportsHotelPage = 'LandedOnReportsHotelPage',
  LandedOnReportsTravelerPage = 'LandedOnReportsTravelerPage',
  LandedOnReportsCompliancePage = 'LandedOnReportsCompliancePage',
  LandedOnReportsTrainlinePage = 'LandedOnReportsTrainlinePage',
  LandedOnReportsWorkforceTrackerPage = 'LandedOnReportsWorkforceTrackerPage',
  LandedOnReportsRoomexPayPage = 'LandedOnReportsRoomexPayPage',
  LandedOnReportsClientFieldPage = 'LandedOnReportsClientFieldPage',
  WorkforceTrackerCountry = 'WorkforceTrackerCountry',
  MyProfileSelected = 'MyProfileSelected',
  PersonalDetailsSelected = 'PersonalDetailsSelected',
  SecuritySectionSelected = 'SecuritySectionSelected',
  GuestbookSectionSelected = 'GuestbookSectionSelected',
  TemporaryApproverSectionSelected = 'TemporaryApproverSectionSelected',
  ClickedOnChangePassword = 'ClickedOnChangePassword',
  ClickedOnCancelResetPassword = 'ClickedOnCancelResetPassword',
  ClickedOnSendResetLink = 'ClickedOnSendResetLink',
  ClickedOnRecentSearch = 'ClickedOnRecentSearch',
  ClickedOnReset = 'ClickedOnReset',
  SelectedLocationFromAutoComplete = 'SelectedLocationFromAutoComplete',
  ApprovalFlowBookingStatus = 'ApprovalFlowBookingStatus',
  RedirectToGroupBookingFrom8Rooms = 'RedirectToGroupBookingFrom8Rooms',
  OpenedLongStayRedirectModal = 'OpenedLongStayRedirectModal',
  RedirectToGroupBookingFromLongStay = 'RedirectToGroupBookingFromLongStay',
  ClickedHotelOverview = 'ClickedHotelOverview',
  ClickedBookARoom = 'ClickedBookARoom',
  ClickedMapViewRoomSelect = 'ClickedMapViewRoomSelect',
  ClickedHotelInformation = 'ClickedHotelInformation',
  ShareHotel = 'ShareHotel',
  EditLocationSearchClicked = 'EditLocationSearchClicked',
  MapHotelPinClicked = 'MapHotelPinClicked',
  SelectHotelFromMapClicked = 'SelectHotelFromMapClicked',
  MapDragAndDrop = 'MapDragAndDrop',
  MapZoomWithMouse = 'MapZoomWithMouse',
  MapZoomWithButtons = 'MapZoomWithButtons',
  LocationSearchClearAllFilters = 'LocationSearchClearAllFilters',
  GetReservationDetailsSoldOut = 'GetReservationDetailsSoldOut',
  RoomSelectPageError = 'RoomSelectPageError',
}

const AllChannels = [LogChannel.Amplitude, LogChannel.Intercom];

export const LogChannelMappings = {
  [EventName.DidSearch]: AllChannels,
  [EventName.RoomSelectPageError]: [LogChannel.Amplitude],
  [EventName.SelectedTopLocation]: [LogChannel.Amplitude],
  [EventName.ClickedHotelOverview]: [LogChannel.Amplitude],
  [EventName.ClickedBookARoom]: [LogChannel.Amplitude],
  [EventName.ClickedHotelInformation]: [LogChannel.Amplitude],
  [EventName.ClickedMapViewRoomSelect]: [LogChannel.Amplitude],
  [EventName.ShareHotel]: [LogChannel.Amplitude],
  [EventName.LandedOnLandingPage]: AllChannels,
  [EventName.ShowMapForHotel]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.ShowMapForLocation]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.LandedOnLocationSearchPage]: AllChannels,
  [EventName.TermsAndConditionsClicked]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.LocationTooLarge]: [LogChannel.Amplitude],
  [EventName.SelectedHotel]: AllChannels,
  [EventName.ClickedRoomDescription]: [LogChannel.Amplitude],
  [EventName.SelectedRecentHotel]: AllChannels,
  [EventName.LandedOnReports]: [LogChannel.Intercom],
  [EventName.ReportDashboard]: [LogChannel.Amplitude],
  [EventName.LandedOnCustomerDetailsPage]: AllChannels,
  [EventName.ClickedCustomerDetailsErrorLink]: AllChannels,
  [EventName.ReservationCreateResponse]: [LogChannel.Amplitude],
  [EventName.FinalizedBooking]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.SentSpecialRequest]: [LogChannel.Amplitude],
  [EventName.ChangeSort]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.ChangedFilter]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.ChangedPriceRangeFilter]: [LogChannel.Amplitude],
  [EventName.PriceRangeFilterInteractions]: [LogChannel.Amplitude],
  [EventName.ChangedStarRatingFilter]: [LogChannel.Amplitude],
  [EventName.LocationSearchResponse]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.ExpandedSearchRadius]: [LogChannel.Amplitude],
  [EventName.LandedOnRoomSelectPage]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.RoomOptionClickResponse]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.SelectedRooms]: AllChannels,
  [EventName.AmendmentButtonClicked]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.AmendGuestClicked]: [LogChannel.Amplitude],
  [EventName.SubmitGuestNameChangeClicked]: [LogChannel.Amplitude],
  [EventName.GuestNameAutoChanged]: [LogChannel.Amplitude],
  [EventName.GuestNameManuallyChanged]: [LogChannel.Amplitude],
  [EventName.ReportDateRange]: [LogChannel.Amplitude],
  [EventName.PWAAvailable]: [LogChannel.Amplitude],
  [EventName.PWAActivated]: [LogChannel.Amplitude],
  [EventName.PWADownloaded]: [LogChannel.Amplitude],
  [EventName.PWADismissed]: [LogChannel.Amplitude],
  [EventName.RoomexPaySplash]: [LogChannel.Amplitude, LogChannel.Intercom],
  [EventName.NoAvailabilityLocation]: [LogChannel.Intercom],
  [EventName.NoAvailabilityHotel]: [LogChannel.Intercom],
  [EventName.LandedGroupBookingPopOut]: [LogChannel.Amplitude],
  [EventName.GroupBookingPopOutSent]: [LogChannel.Amplitude],
  [EventName.LandedGroupBookingHelp]: [LogChannel.Amplitude],
  [EventName.GroupBookingHelpSent]: [LogChannel.Amplitude],
  [EventName.LandedFAQHelpPage]: [LogChannel.Amplitude],
  [EventName.LandedContactHelpPage]: [LogChannel.Amplitude],
  [EventName.BookingEnquirySent]: [LogChannel.Amplitude],
  [EventName.GeneralFeedbackSent]: [LogChannel.Amplitude],
  [EventName.LandedlCancellationHelpPage]: [LogChannel.Amplitude],
  [EventName.ApartmentRequestSent]: [LogChannel.Amplitude],
  [EventName.LandedOnBookingsPage]: [LogChannel.Amplitude],
  [EventName.LandedOnViewConfirmationPage]: [LogChannel.Amplitude],
  [EventName.LandedHotelDetailsPage]: [LogChannel.Amplitude],
  [EventName.GalleryImageClicked]: [LogChannel.Amplitude],
  [EventName.SelectedMoreOptions]: [LogChannel.Amplitude],
  [EventName.AmendDates]: [LogChannel.Amplitude],
  [EventName.CompleteAutoDateChange]: [LogChannel.Amplitude],
  [EventName.SubmitManualDateChange]: [LogChannel.Amplitude],
  [EventName.DateChangeNoAvailability]: [LogChannel.Amplitude],
  [EventName.RequestedRoomexPayCardAfterBooking]: [LogChannel.Amplitude],
  [EventName.AddedRoomexPayCardAfterBooking]: [LogChannel.Amplitude],
  [EventName.RoomexPayLead]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsBookerPage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsHotelPage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsTravelerPage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsCompliancePage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsTrainlinePage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsWorkforceTrackerPage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsRoomexPayPage]: [LogChannel.Amplitude],
  [EventName.LandedOnReportsClientFieldPage]: [LogChannel.Amplitude],
  [EventName.WorkforceTrackerCountry]: [LogChannel.Amplitude],
  [EventName.MyProfileSelected]: [LogChannel.Amplitude],
  [EventName.PersonalDetailsSelected]: [LogChannel.Amplitude],
  [EventName.SecuritySectionSelected]: [LogChannel.Amplitude],
  [EventName.ClickedOnChangePassword]: [LogChannel.Amplitude],
  [EventName.ClickedOnCancelResetPassword]: [LogChannel.Amplitude],
  [EventName.ClickedOnSendResetLink]: [LogChannel.Amplitude],
  [EventName.ClickedOnReset]: [LogChannel.Amplitude],
  [EventName.SelectedLocationFromAutoComplete]: [LogChannel.Amplitude],
  [EventName.ClickedOnRecentSearch]: [LogChannel.Amplitude],
  [EventName.ApprovalFlowBookingStatus]: [LogChannel.Amplitude],
  [EventName.RedirectToGroupBookingFrom8Rooms]: [LogChannel.Amplitude],
  [EventName.OpenedLongStayRedirectModal]: [LogChannel.Amplitude],
  [EventName.RedirectToGroupBookingFromLongStay]: [LogChannel.Amplitude],
  [EventName.EditLocationSearchClicked]: [LogChannel.Amplitude],
  [EventName.MapHotelPinClicked]: [LogChannel.Amplitude],
  [EventName.SelectHotelFromMapClicked]: [LogChannel.Amplitude],
  [EventName.MapDragAndDrop]: [LogChannel.Amplitude],
  [EventName.MapZoomWithButtons]: [LogChannel.Amplitude],
  [EventName.MapZoomWithMouse]: [LogChannel.Amplitude],
  [EventName.LocationSearchClearAllFilters]: [LogChannel.Amplitude],
  [EventName.GetReservationDetailsSoldOut]: [LogChannel.Amplitude],
};
